const typesParsing = (string, uppercase = false) => {
  if (!string) return false;

  const exceptionWords = ['dan']; // add more if needed

  let result = string
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => {
      const lower = word.toLowerCase();
      if (exceptionWords.includes(lower)) return lower;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

  return uppercase ? result.toUpperCase() : result;
};

const requestTypeIndo = (str) => {
  const strLowerCase = str.toLowerCase();
  switch(strLowerCase) {
    case 'services':
      return 'Pelayanan';
    case 'feature':
      return 'Fitur';
    default:
      return str.charAt(0).toUpperCase();
  }
}

const textIntoLink_ = ({ url, maxLength = 100, className = "", style = {} }) => {
  const safeUrl = typeof url === "string" ? url : "";

  if (!safeUrl) return null;

  const displayText =
    safeUrl.length > maxLength ? `${safeUrl.slice(0, maxLength)}...` : safeUrl;

  return (
    <a
      href={safeUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    >
      {displayText}
    </a>
  );
};

const textIntoLink = ({ url, maxLength = 100 }) => {
  if (!url || typeof url !== "string") return "";

  const isUrl = /^(https?:\/\/[^\s]+)/i.test(url);
  const displayText = url.length > maxLength ? `${url.slice(0, maxLength)}...` : url;

  return isUrl
    ? `<a href="${url}" target="_blank" rel="noopener noreferrer">${displayText}</a>`
    : displayText;
};

export { typesParsing, requestTypeIndo, textIntoLink };
